var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-bulletin"},[_c('div',{staticClass:"form-bulletin-description-company"},[_c('div',{staticClass:"content-date-company"},[_c('PhoneIcon'),_vm._v(" "),_c('p',{class:[
					'item-date-company',
					{ 'loading': _vm.indeterminate } ]},[_vm._v(_vm._s(_vm.getCommerceData.phone))])],1),_vm._v(" "),_c('div',{staticClass:"content-date-company"},[_c('EmailIcon'),_vm._v(" "),_c('p',{class:[
					'item-date-direction email',
					{ 'loading': _vm.indeterminate } ]},[_vm._v("Correo: "+_vm._s(_vm.getCommerceData.email))])],1),_vm._v(" "),_c('div',{staticClass:"content-date-company"},[_c('LocationIcon'),_vm._v(" "),_c('p',{class:[
					'item-date-direction',
					{ 'loading': _vm.indeterminate } ]},[_vm._v(_vm._s(_vm.getCommerceData.address))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-592af639","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/form/form-bulletin.vue
// module id = 1079
// module chunks = 19